import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const Button = ({
  children,
  colorType = 'currency',
  size = 'md',
  ...rest
}: any) => {
  return (
    <ButtonStyle colorType={colorType} size={size} {...rest}>
      {children}
    </ButtonStyle>
  );
};

export default Button;

interface ButtonProps {
  colorType: 'currency' | 'coin';
  size: 'sm' | 'md' | 'lg';
}

const ButtonStyle = styled.button<ButtonProps>`
  width: 150px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  background: #ddd;
  border-radius: 3px;
  overflow: hidden;
  font-family: 'roboto' !important;
  font-weight: 600;
  background: #ffeee4;
  color: #000;
  ${({ colorType }) =>
    colorType === 'currency'
      ? css`
          color: #e63740;
          background-color: #ffeee4;
        `
      : colorType === 'coin' &&
        css`
          color: #000000;
          background-color: #ffe976;
        `}
`;
